import { useExtendedTelegramMutation } from "@workspace/casino_core/mutations/ExtendedTelegramMutation.client";
import filterAuthResponse from "../helpers/utils";

const useHandleTelegramAuthenticate = () => {
  const [completeTelegramRegistration, { loading }] =
    useExtendedTelegramMutation();
  const handleTelegramAuthenticate = async (
    variables: AuthVariables,
    accessToken: string,
  ) => {
    const response = await completeTelegramRegistration({
      ...variables,
      telegramData: accessToken,
    });
    return filterAuthResponse(response?.data?.userManagementAuthWithTelegram);
  };
  return {
    handleTelegramAuthenticate,
    loading,
  };
};

export default useHandleTelegramAuthenticate;
